<div #icon class="gesture-refresher-icon">
  <ion-icon name="refresh-outline"></ion-icon>
</div>
